<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <c-table
              ref="inTable"
              title="내부참석자 목록"
              :columns="inGrid.columns"
              gridHeight="250px"
              :data="data.attendeeInModels"
              :filtering="false"
              :columnSetting="false"
              :usePaging="false"
              noDataLabel="내부참석자를 추가하세요."
              :hideBottom="true"
              :editable="editable"
              :checkClickFlag="false"
              :isExcelDown="false"
              rowKey="proceedingsAttendeeId"
              selection="multiple"
            >
              <template slot="table-button">
                <q-btn-group outline>
                  <c-btn v-if="editable" :showLoading="false" label="추가" icon="add" @btnClicked="addInAttendee" />
                  <c-btn v-if="editable && data.attendeeInModels.length > 0" :showLoading="false"  label="삭제" icon="remove" @btnClicked="removeInAttendee" />
                </q-btn-group>
              </template>
            </c-table>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <c-table
              ref="outTable"
              title="외부참석자 목록"
              :columns="outGrid.columns"
              gridHeight="250px"
              :data="data.attendeeOutModels"
              :filtering="false"
              :columnSetting="false"
              :usePaging="false"
              noDataLabel="외부참석자를 추가하세요."
              :hideBottom="true"
              :checkClickFlag="false"
              :isExcelDown="false"
              :editable="editable"
              rowKey="proceedingsAttendeeId"
              selection="multiple"
            >
              <template slot="table-button">
                <q-btn-group outline>
                  <c-btn v-if="editable" :showLoading="false" label="추가" icon="add" @btnClicked="addOutAttendee" />
                  <c-btn v-if="editable && data.attendeeOutModels.length > 0" :showLoading="false"  label="삭제" icon="remove" @btnClicked="removeOutAttendee" />
                </q-btn-group>
              </template>
            </c-table>
          </div>
        </div>  
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-card title="관련 회의록" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-sm-12 col-md-12 col-lg-12" style="height: 460px">
                <c-upload 
                  :attachInfo="attachInfo"
                  :editable="editable"
                  label="관련 회의록">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar';
export default {
  name: 'proceedings-result',
  props: {
    data: {
      type: Object,
      default: () => ({
        proceedingsId: '',
        attendeeInModels: [],
        attendeeOutModels: [],
        deleteAttendeeInModels: [],
        deleteAttendeeOutModels: [],
      }),
    },
    attachInfo: {
      type: Object,
      default: () => ({
        isSubmit: '',
        taskClassCd: 'OSH_PROCEEDINGS',
        taskKey: '',
      }),
    },
  },
  data() {
    return {
      attachable: false,
      mappingType: 'POST',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      inGrid: {
        columns: [
          {
            name: 'attendeeDeptName',
            field: 'attendeeDeptName',
            label: '부서',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'attendeeUserName',
            field: 'attendeeUserName',
            label: '성명',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'attendeeJobName',
            field: 'attendeeJobName',
            label: '직책',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            type: 'textarea',
            align: 'left',
            style: 'width: 200px',
          },
        ],
        data: [],
      },
      outGrid: {
        columns: [
          {
            name: 'attendeeBelong',
            field: 'attendeeBelong',
            label: '소속',
            type: 'text',
            align: 'center',
            style: 'width: 80px',
            required: true,
          },
          {
            name: 'attendeeUserName',
            field: 'attendeeUserName',
            label: '성명',
            style: 'width: 80px',
            type: 'text',
            required: true,
            align: 'center',
          },
          {
            name: 'attendeeJobName',
            field: 'attendeeJobName',
            label: '직책',
            type: 'text',
            style: 'width: 80px',
            align: 'center',
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            type: 'textarea',
            align: 'left',
            style: 'width: 200px',
          },
        ],
        data: [],
      },
      realKey: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
    },
    addInAttendee() {
      this.popupOptions.title = "내부참석자 검색"; // 내부참석자 검색
      this.popupOptions.param = {
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '60%';
      this.popupOptions.isFull = false;
      this.popupOptions.closeCallback = this.closeUserPopup;

    },
    closeUserPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          let index = this.$_.findIndex(this.data.attendeeInModels, {
            attendeeUserId: _item.userId,
          });
          if (index === -1) {
            this.data.attendeeInModels.splice(0, 0, {
              proceedingsId: this.popupParam.proceedingsId,
              proceedingsAttendeeId: uid(),
              attendeeType: '1',
              attendeeUserId: _item.userId,
              attendeeUserName: _item.userName,
              attendeeDeptName: _item.deptName,
              attendeeJobName: _item.jobName,
              remark: '',
              chgUserId: this.$store.getters.user.userId,
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C'
            })
          }
        })
      }
    },
    removeInAttendee() {
      let selectData = this.$refs['inTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteAttendeeInModels) {
            this.data.deleteAttendeeInModels = []
          }
          if (this.$_.findIndex(this.data.deleteAttendeeInModels, { proceedingsAttendeeId: item.proceedingsAttendeeId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteAttendeeInModels.push(item)
          }
          this.data.attendeeInModels = this.$_.reject(this.data.attendeeInModels, item)
        })
      }
    },
    addOutAttendee() {
      this.data.attendeeOutModels.splice(0, 0, {
        proceedingsId: this.popupParam.proceedingsId,
        proceedingsAttendeeId: uid(),
        attendeeType: '2',
        attendeeUserId: '',
        attendeeUserName: '',
        attendeeJobName: '',
        remark: '',
        attendeeBelong: '',
        chgUserId: this.$store.getters.user.userId,
        regUserId: this.$store.getters.user.userId,
        editFlag: 'C'
      })
    },
    removeOutAttendee() {
      let selectData = this.$refs['outTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          if (!this.data.deleteAttendeeOutModels) {
            this.data.deleteAttendeeOutModels = []
          }
          if (this.$_.findIndex(this.data.deleteAttendeeOutModels, { proceedingsAttendeeId: item.proceedingsAttendeeId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteAttendeeOutModels.push(item)
          }
          this.data.attendeeOutModels = this.$_.reject(this.data.attendeeOutModels, item)
        })
      }
    },
  }
};
</script>
